"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Analytics = _interopRequireWildcard(require("../analytics"));

var _AuthContext = _interopRequireDefault(require("./AuthContext"));

var _DefaultAuthComponent = _interopRequireDefault(require("./DefaultAuthComponent"));

var _keycloakJs = _interopRequireDefault(require("keycloak-js"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var KeycloakProvider = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2.default)(KeycloakProvider, _Component);

  function KeycloakProvider(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    var config = props.authentication.keycloak.config;
    _this.state = {
      initializing: true
    };
    _this.instance = new _keycloakJs.default(config);
    _this.init = _this.init.bind((0, _assertThisInitialized2.default)(_this));
    _this.login = _this.login.bind((0, _assertThisInitialized2.default)(_this));
    _this.logout = _this.logout.bind((0, _assertThisInitialized2.default)(_this));
    _this.hasSomeRole = _this.hasSomeRole.bind((0, _assertThisInitialized2.default)(_this));
    _this.hasAllRoles = _this.hasAllRoles.bind((0, _assertThisInitialized2.default)(_this));
    _this.setInitOptions = _this.setInitOptions.bind((0, _assertThisInitialized2.default)(_this));
    _this.loadUserInfo = _this.loadUserInfo.bind((0, _assertThisInitialized2.default)(_this));
    _this.onInitSuccessfully = _this.onInitSuccessfully.bind((0, _assertThisInitialized2.default)(_this));
    _this.updateKeycloakToken = _this.updateKeycloakToken.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  var _proto = KeycloakProvider.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props$authentic = this.props.authentication.keycloak.initOptions,
        initOptions = _this$props$authentic === void 0 ? {} : _this$props$authentic;

    var kcInitOptions = _jsCookie.default.getJSON('KC_INIT_OPTIONS');

    if (initOptions) {
      this.init((0, _extends2.default)({}, initOptions, kcInitOptions));
    } else {
      this.init(initOptions);
    }
  };

  _proto.logout = function logout(options) {
    _jsCookie.default.remove('KC_INIT_OPTIONS');

    Analytics.set({
      islogged: false
    });
    Analytics.set({
      userId: undefined
    });
    return this.instance.logout(options);
  };

  _proto.login = function login(options) {
    _jsCookie.default.remove('KC_INIT_OPTIONS');

    return this.instance.login(options);
  };

  _proto.hasSomeRole = function hasSomeRole(roles) {
    var authenticated = this.state.authenticated;
    return authenticated && roles.some(this.instance.hasRealmRole);
  };

  _proto.hasAllRoles = function hasAllRoles(roles) {
    var authenticated = this.state.authenticated;
    return authenticated && roles.every(this.instance.hasRealmRole);
  };

  _proto.setInitOptions = function setInitOptions(_ref) {
    var refreshExpiresIn = _ref.refreshExpiresIn,
        initOptions = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["refreshExpiresIn"]);
    return this.init((0, _extends2.default)({}, initOptions, {
      checkLoginIframe: false
    })).then(function (authContext) {
      var expires = refreshExpiresIn ? new Date(new Date().getTime() + refreshExpiresIn * 1000) : undefined;

      _jsCookie.default.set('KC_INIT_OPTIONS', initOptions, {
        expires: expires
      });

      return authContext;
    });
  };

  _proto.updateKeycloakToken = function updateKeycloakToken(keycloak) {
    this.instance.updateToken(40).success(function (refreshed) {
      if (refreshed) {
        console.debug('[KEYCLOAK] Token refreshed' + refreshed);
      } else {
        console.warn('[KEYCLOAK] Token not refreshed, valid for ' + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
      }
    }).error(function (error) {
      console.error('[KEYCLOAK] Failed to refresh token: ' + error);
    });
  };

  _proto.loadUserInfo = function loadUserInfo() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.instance.loadUserInfo().success(function (userInfo) {
        console.debug('[KEYCLOAK] UserInfo loaded' + userInfo);
        resolve((0, _extends2.default)({}, userInfo, {
          roles: _this2.instance.realmAccess.roles
        }));
      }).error(function (error) {
        console.error('[KEYCLOAK] Failed to load userInfo: ' + error);
        reject(error);
      });
    });
  };

  _proto.onInitSuccessfully = function onInitSuccessfully(authenticated) {
    var _this3 = this;

    console.debug('[KEYCLOAK] init successfully. Authenticated: ' + authenticated);
    return new Promise(function (resolve, reject) {
      if (authenticated) {
        setInterval(function () {
          _this3.updateKeycloakToken(_this3.instance);
        }, 30000);

        _this3.loadUserInfo().then(function (userInfo) {
          Analytics.set({
            islogged: true
          });
          Analytics.set({
            userId: userInfo.sub
          });
          resolve({
            userInfo: userInfo
          });
        }).catch(function (error) {
          return reject(error);
        });
      } else {
        resolve({
          userInfo: null
        });
      }
    });
  };

  _proto.init = function init(initOptions) {
    var _this4 = this;

    if (initOptions === void 0) {
      initOptions = {};
    }

    var required = this.props.authentication.required;
    var keycloakInitOptions = (0, _extends2.default)({}, required ? {
      onLoad: 'login-required'
    } : {
      onLoad: 'check-sso'
    }, initOptions);
    console.debug('[KEYCLOAK] initializing keycloak: ' + keycloakInitOptions);
    return new Promise(function (resolve, reject) {
      _this4.setState({
        initializing: true
      });

      _this4.instance.init(keycloakInitOptions).success(function (authenticated) {
        _this4.onInitSuccessfully(authenticated).then(function (_ref2) {
          var userInfo = _ref2.userInfo;

          _this4.setState({
            authenticated: authenticated,
            userInfo: userInfo,
            error: null,
            initializing: false
          }, function () {
            resolve(_this4.authState);
          });
        }).catch(function (error) {
          _this4.setState({
            authenticated: authenticated,
            error: error,
            userInfo: null,
            initializing: false
          }, function () {
            reject(_this4.authState);
          });
        });
      }).error(function (error) {
        console.error('[KEYCLOAK] init failure: ' + error);

        _this4.setState({
          error: error,
          userInfo: null,
          initializing: false,
          authenticated: false
        }, function () {
          reject(_this4.authState);
        });
      });
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        authentication = _this$props.authentication;
    var _this$state = this.state,
        authenticated = _this$state.authenticated,
        initializing = _this$state.initializing;
    var _authentication$AuthC = authentication.AuthComponent,
        AuthComponent = _authentication$AuthC === void 0 ? _DefaultAuthComponent.default : _authentication$AuthC,
        required = authentication.required;
    var content = children;

    if (initializing || required && !authenticated) {
      content = /*#__PURE__*/_react.default.createElement(AuthComponent, {
        code: "401"
      });
    }

    return /*#__PURE__*/_react.default.createElement(_AuthContext.default.Provider, {
      value: this.authState
    }, content);
  };

  (0, _createClass2.default)(KeycloakProvider, [{
    key: "authState",
    get: function get() {
      var authentication = this.props.authentication;
      var AuthComponent = authentication.AuthComponent;
      var _this$instance = this.instance,
          authServerUrl = _this$instance.authServerUrl,
          realm = _this$instance.realm,
          clientId = _this$instance.clientId;
      return (0, _extends2.default)({
        AuthComponent: AuthComponent,
        setInitOptions: this.setInitOptions,
        keycloak: this.instance,
        login: this.login,
        logout: this.logout,
        recoveryUrl: authServerUrl + "realms/" + realm + "/login-actions/reset-credentials?client_id=" + clientId,
        hasSomeRole: this.hasSomeRole,
        hasAllRoles: this.hasAllRoles
      }, this.state);
    }
  }]);
  return KeycloakProvider;
}(_react.Component);

KeycloakProvider.propTypes = {
  authentication: _propTypes.default.shape({
    required: _propTypes.default.bool,
    AuthComponent: _propTypes.default.elementType,
    keycloak: _propTypes.default.shape({
      initOptions: _propTypes.default.object,
      config: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]).isRequired
    })
  }),
  children: _propTypes.default.node
};
KeycloakProvider.displayName = 'KeycloakProvider';
var _default = KeycloakProvider;
exports.default = _default;